export default {
  init() {

  },
  finalize() {
    $('#selection-next').on('click', function() {
      const selectionType = $('input[name="reg-type"]:checked').val();
      $('.selection-registration-type').stop().fadeOut(350);

      setTimeout(function() {
        if (selectionType == 'cylch-meithrin') {
          $('.cylch-meithrin-form').stop().fadeIn(350);
        } else {
          $('.day-nursery-form').stop().fadeIn(350);
        }
      }, 350);
    });

    // pick up checkboxes
    if ($('input[type="checkbox"]').length > 0) {
      $('input[type="checkbox"]').each(function () {
        const $this_ = $(this);

        $this_.removeClass();
        $this_.addClass('location-checkbox custom-control-input');
        $this_.siblings('span').removeClass().addClass('custom-control-label');
        $this_.parent().addClass('custom-control custom-checkbox');
      });
    }

    // section togglers
    if ($('.section-toggle').length > 0) {
      $('.section-toggle').each(function () {
        $(this).on('click', function () {
          if ($(this).html() == '-') {
            $(this).html('+');
          } else {
            $(this).html('-');
          }

          $(this).closest('.section-group').find('.section-body').stop().slideToggle(300);
        });
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-annual-membership.js